export const schTime = {
  '00:00': '00:00',
  '00:59': '01:00',
  '01:59': '02:00',
  '02:59': '03:00',
  '03:59': '04:00',
  '04:59': '05:00'
}

export const getOptionsStatus = () => {
  return Object.keys(status).map((key) => {
    return {
      id: key,
      label: status[key]
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/bookings/dataTimes.js